<template>
	<div class="container" id="risk-matrix">
		<div class="dashboardriskdisplay">
			<v-col cols="5.5" lg="6" md="12" sm="12" class="riskpointdashboard">
				<v-col class="createriskdashboard">
					<div class="risk-chart-wrapper" style="margin-left: 30px;">
						<RiskmatrixChart :offsetValue="0" />
						<div class="horizontal-text">Probability</div>
					</div>

				</v-col>
			</v-col>
			<v-col cols="6" lg="6" md="12" sm="12" class="scoredashboardfull">
				<v-card class="mx-auto" max-width="600" style="width: 600px;margin-top: 15px;">
				<br/>
				<v-card-text>
					<p class="text-h5 text--primary" >
						Title : {{ selectedTitle }}
					</p>
					<div class="text-h6 ">
						{{selectedDescription }}
					</div>
				</v-card-text>
			</v-card>
			</v-col>

		</div>
	</div>
</template>

<script>
import RiskmatrixChart from "./RiskmatrixChart.vue"
import { riskAPI } from "../api/csr/risk"
import LoadingState from "../consts/LoadingState"
import { mapGetters } from "vuex"

export default {
	data() {
		return {
			index1: 0,
			index: [],
			points: [],
			horizontal: "",
			vertical: "",
			rows: [],
		}
	},

	components: {
		RiskmatrixChart,
	},
	computed: {
		...mapGetters([
			"selectedId",
			"selectedYear",
			"selectedTitle",
			"selectedDescription",
		]),
	},
	mounted() {
		this.loadRisk()
	},

	watch: {
		selectedId(newVal) {
			console.log("Selected ID changed:", newVal)
		},
		selectedTitle(newVal) {
			console.log("Selected Title changed:", newVal)
		},
		selectedDescription(newVal) {
			console.log("Selected Description changed:", newVal)
		},
	},

	methods: {
		isPoint(x, y) {
			return this.points.some((point) => point.x === x && point.y === y)
		},
		addPoint(c, p) {
			this.index1++
			const point = {
				x: parseInt(Math.abs(c - 25)),
				y: parseInt(Math.abs(p - 1)),
				risk: this.index1,
			}

			this.points.push(point)
		},
		// Add a new row to the table
		addRiskRow() {
			const newRow = {}
			// Initialize each column's value to an empty string
			for (let i = 1; i <= 8; i++) {
				newRow[`col${i}`] = ""
			}
		},
		loadRisk() {
			riskAPI
				.getAll()
				.then((data) => {
					let newdata = data[0]
					for (let entry of newdata) {
						this.vertical = entry.Consequence
						this.horizontal = entry.Probability
						this.rows.push(entry)
						this.addRiskRow()
					}
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
	},
}
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 0px;
	margin-top: 0px;
}
.spanclass1 {
	display: flex;
}
.spanclass2 {
	margin-top: -500px;
	margin-bottom: 500px;
	margin-left: 700px;
	display: flex;
	flex-direction: column;
}

.spanclass2 input {
	border: 1px solid #ccc;
	padding: 10px;
	padding-top: 0px;
}

.spanclass2input1 {
	width: 600px;
	height: 50px;
	padding-top: 0px;
	margin-top: 0px;
	align-items: top;
	font-size: 1.2rem;
}

.spanclass2 h3 {
	margin-left: 0px;
}

.spanclass2input2 {
	border: 1px solid gray;
	display: flex;
	width: 600px;
	height: 200px;
	padding-top: 4px;
	padding-left: 2px;
	margin-top: 0px;
	align-items: top;
	font-size: 1rem;
}
.probabilityclass {
	margin-left: -800px;
	margin-top: -130px;
	color: #217b7f;
	letter-spacing: 10px;
	font-weight: 1000;
}

.riskpointdashboard {
	display: flex;
	height: 600px;
	width: 750px;
	border: 1px solid #ddd;
	margin-left: 35px;
	border-radius: 10px;
	align-items: center;
	justify-self: center;
	padding-left: 76px;
}
.createriskdashboard .risk-chart-wrapper {
	transform: scale(1);
}

.createriskdashboard .risk-chart-wrapper .divcolumn {
	margin-left: -120px !important;
	
}

.createriskdashboard .createriskbtn {
	margin-top: -75px !important;
}
.horizontal-text {
	margin-top: 10px;
	margin-right: -30px ;
	margin-bottom: 10px;
	color: #217b7f;
	letter-spacing: 10px;
	font-weight: 1000;
	font-size: 16px;
}
@media (max-width: 1267px) {
	.dashboardriskdisplay {
		flex-direction: column;
	}

	.dashboardriskdisplay .scoredashboardfull {
		order: -1;
		width: 100%;
		margin-bottom: 15px;
	}

	.riskpointdashboard {
		width: 720px;
		margin-left: -40px;

		
	}
}
</style>
